import React from 'react';
import Title from '../../partials/title';
import ScrollAnimation from 'react-animate-on-scroll';

// August 6th: refactored for responsiveness
const CheckIn = () => {
    return (
        <div className="w3-container w3-content pt-8 pb-8">
            <div className="d-flex flex-row">
                <ScrollAnimation animateIn="fadeInLeft" animateOnce={true} className="w-100">
                    <img alt="" className="w-100" src="/images/others/checkin.png" />
                </ScrollAnimation>
                <div style={{ width: 30 }} />
                <div className="w-100 d-flex flex-column justify-content-center">
                    <Title text="Check-In Procedure" />
                    <p className="margin-top gray">To Check in for qualifying events is typically held at the event site unless otherwise noted on the event's information page. A team representative should arrive at the fields at least one hour before the team's first game to check the team in.</p>
                </div>
            </div>
            <ScrollAnimation animateIn="fadeInLeft" animateOnce={true} className="d-flex flex-column margin-top-double hind">
                <h3>1. ROSTER / WAIVER FORM</h3>
                <p className="gray">We're excited to announce that all Challenge Sports waivers are now digital - no more paper! Effective December 16, 2018 all participant waivers must be submitted via the Sports Logic "SL Team App". No more printing, signing, and bringing paper to the tournament - now it only takes a few seconds from the palm of your hand! Online waiver form is available in SL Team App. Once properly signed, this will cover a player for any Challenge Sports event. </p>
                <h3>2. PROOF OF AGE</h3>
                <p className="gray">Proof of Age is required for each player, unless the player is showing 'Verified' in Sports Logic system, they will not be able to participate in the event. Any one of the following are acceptable as proof of a player's age: Birth certificate, Passport, verified Player Pass or Driver's license/state issued ID card. Copies of any of these are acceptable.</p>
                <h3>3. ROSTER CHANGES</h3>
                <p className="gray">If you need to change your roster from the one that was submitted when you registered, make the changes by logging into your Sports Logic Account or by using the SL Team App on your phone. If you have additional questions about how to roster, please reference the <a href="https://www.sportslogic.net/help/" target="_blank" rel="noopener noreferrer">Sports Logic User Guide</a></p>
            </ScrollAnimation>
        </div>
    );
}

export default CheckIn;



// WEBPACK FOOTER //
// ./src/components/information/partials/check_in.js